import { Message } from './types/chat';

const greeting = window.chatConfig?.greeting || 'Hallo, ich bin Ella. Was kann ich für dich finden?';
const error = window.chatConfig?.error || 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.';
const hallucination = window.chatConfig?.hallucination || 'Es tut mir leid, ich habe einen Fehler gemacht. Bitte warte einen Moment, ich versuche es erneut.';
const remediation = window.chatConfig?.remediation || `I included links that were not from my search results. I will search again and only provide links that I found in the search results.`;
const failure = window.chatConfig?.failure || 'Es tut mir leid, es ist ein Fehler aufgetreten, den ich nicht beheben kann. Bitte lade die Seite neu, um erneut zu beginnen.';

export const defaults = {
    greeting,
    error,
    hallucination,
    remediation,
    failure,
}

export const confirmations = {
    delete: 'Möchtest du deine Zustimmung widerrufen? Dabei wird der gesamte Chat-Verlauf gelöscht und kann nicht wiederhergestellt werden.',
    new: 'Möchtest du einen neuen Chat starten?',
}

export const createMessage = (role: Message['role'], content: string, isStreaming: boolean = false): Message => {
    return {
        timestamp: new Date(),
        role,
        content,
        isStreaming,
        tool_calls: [],
    };
}
